import { createSelector } from 'reselect';
import { performanceChartSelector } from './simple-selectors';

export const performanceChartPlayerTwoDataSelector = createSelector(
    performanceChartSelector,
    (performanceChart) => performanceChart.playerTwoData
);
